import "../../_generated_templates.js";
import "../base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.IntroForm = class IntroForm extends AssessmentBuilder.Views.Base {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  // RENDERING

  render() {
    this.$el.html(this.template(this.model.attributes));
    super.render(...arguments);
    Sparkle.Components.Wysiwyg.attach(this.$("textarea[name=instructions]"), { toolset: "extended" });
    Sparkle.Components.Wysiwyg.attach(this.$("textarea[name=footer]"), { toolset: "extended" });

    return this;
  }
};
AssessmentBuilder.Views.IntroForm.prototype.tagName = "intro-form";
AssessmentBuilder.Views.IntroForm.prototype.className = "assessment-form --view-intro";
AssessmentBuilder.Views.IntroForm.prototype.template = _.template(AssessmentBuilder.Templates.Intro.form);
AssessmentBuilder.Views.IntroForm.prototype.events = { change: "handleAttributeChange" };
